/* ABC: точки под фотографиями в карточке каталога — показывают, сколько
   кадров и на каком мы сейчас. У темы для карточки их нет вообще:
   slideshow-controls она рендерит только в баннерах.

   Точки ставим после галереи, перед подписями. Клик по точке —
   переход к кадру. */
(function () {
  /* 25.09: только видимые кадры — в сетке каталога часть слайдов скрыта
     (GRID: ITEM / MODEL, assets/abc-grid-view.js) */
  function slides(comp) {
    return Array.from(comp.querySelectorAll('slideshow-slide:not([hidden])'));
  }
  /* Активный кадр тема помечает aria-hidden="false" (НЕ атрибутом hidden —
     на этом я сначала ошибся, и точки не переключались). */
  function currentIndex(comp) {
    var list = slides(comp);
    for (var i = 0; i < list.length; i++) {
      if (list[i].getAttribute('aria-hidden') === 'false') return i;
    }
    return 0;
  }

  function paint(comp, dots) {
    var cur = currentIndex(comp);
    Array.prototype.forEach.call(dots.children, function (d, i) {
      d.classList.toggle('is-current', i === cur);
      d.setAttribute('aria-current', i === cur ? 'true' : 'false');
    });
  }

  function build(comp) {
    if (comp.dataset.abcDots) return;
    var list = slides(comp);
    if (list.length < 2) return;            // один кадр — точки не нужны
    comp.dataset.abcDots = '1';

    var dots = document.createElement('div');
    dots.className = 'abc-dots';
    list.forEach(function (_, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'abc-dots__dot';
      b.setAttribute('aria-label', 'Photo ' + (i + 1));
      b.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();               // чтобы не открылся товар
        if (typeof comp.select === 'function') comp.select(i);
        setTimeout(function () { paint(comp, dots); }, 50);
      });
      dots.appendChild(b);
    });

    /* точки лежат ПОВЕРХ фотографии, у нижнего края — как на abcclothes.ru,
       а не отдельной строкой под кадром */
    var host = comp.closest('.card-gallery') || comp;
    host.appendChild(dots);
    paint(comp, dots);

    /* кадр меняют стрелки, свайп и наш скрипт — следим за атрибутом hidden */
    new MutationObserver(function () { paint(comp, dots); })
      .observe(comp, { attributes: true, subtree: true, attributeFilter: ['aria-hidden'] });
  }

  function scan() {
    document.querySelectorAll('.product-card slideshow-component').forEach(build);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  /* 25.09: GRID ITEM/MODEL меняет число видимых кадров атрибутом hidden — это не
     childList, наблюдатель не видит; abc-grid-view.js зовёт пересборку сам */
  window.abcCardDotsScan = scan;
})();

/* ABC (ПК), наведение на карточку без сдвига высоты (владелец, 22.09):
   на месте строки «WOMEN · 3 COLORS» показываем
   - квадратики цветов, если у товара есть другие цвета;
   - иначе размеры.
   Нужный блок кладём внутрь строки, CSS подменяет её на том же месте. */
(function () {
  /* 25.09: проверка «ПК с мышью» — при каждом проходе, а не один раз при загрузке:
     страница, открытая в режиме телефона (DevTools, узкое окно), потом не
     включала подсказки при наведении вовсе */
  var mq = matchMedia('(min-width: 750px) and (hover: hover)');
  function move() {
    if (!mq.matches) return;
    document.querySelectorAll('.product-card').forEach(function (c) {
      var meta = c.querySelector('.abc-card-meta');
      if (!meta || meta.querySelector(':scope > .abc-hover')) return;
      var col = c.querySelector('.abc-card-colors'), rows = c.querySelector('.abc-card-rows');
      var hasColors = col && col.querySelectorAll('.abc-card-colors__square').length > 1;
      var pick = hasColors ? col : rows;
      if (!pick) return;
      pick.classList.add('abc-hover');
      meta.appendChild(pick);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', move); else move();
  if (mq.addEventListener) mq.addEventListener('change', move);
  var q = false;
  new MutationObserver(function () { if (q) return; q = true; setTimeout(function () { q = false; move(); }, 80); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();

/* ABC: первый экран — плитки WOMEN | MEN ровно до низа окна. Высоту шапки и
   бегущей строки не угадываем числами, а меряем: реальный верх плиток. +1px —
   чтобы из-под них не выглядывала полоска следующего баннера (владелец, 22.09). */
(function () {
  function fit() {
    var t = document.querySelector('.abc-tiles');
    if (!t || !matchMedia('(min-width: 750px)').matches) return;
    var sc = document.querySelector('.page-wrapper');
    var scrolled = (sc && sc.scrollTop) || window.scrollY || 0;
    var top = t.getBoundingClientRect().top + scrolled;
    t.style.height = Math.ceil(window.innerHeight - top + 1) + 'px';
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fit); else fit();
  addEventListener('load', fit);
  addEventListener('resize', fit);
})();

/* ABC: панель фильтров — все группы сразу раскрыты (владелец, 22.09: как у
   Balenciaga, но в нашем стиле). Тема перерисовывает панель после каждого
   выбора — поэтому следим и раскрываем заново. */
(function () {
  function openAll() {
    document.querySelectorAll('dialog[open] .facets details.facets__panel:not([open])').forEach(function (d) { d.open = true; });
  }
  var q = false;
  new MutationObserver(function () { if (q) return; q = true; setTimeout(function () { q = false; openAll(); }, 30); })
    .observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] });
})();

/* ABC: фильтр COLOR — ГРУППЫ цветов вместо 46 оттенков (решение владельца 24.09).
   В товарах цвет записан точным оттенком (WASABI, OLIVE, KHAKI…), а покупатель
   ищет «зелёное». Поэтому исходные галочки прячем и рисуем свои квадратики-группы:
   клик по группе включает/выключает все её оттенки сразу, дальше тема сама
   пересчитывает товары. Камуфляж — не заливкой, а принтом (abc-camo-*.webp).
   Словарь групп один на фильтр и поиск: snippets/abc-color-group.liquid,
   на страницу он попадает как <script id="abc-color-groups"> (sections/abc-marquee).
   Оттенок, которого нет в словаре, показывается своим квадратиком (hex из
   templates/page.abccolors.liquid), чтобы ничего не пропало. */
(function () {
  var NAME = 'filter.p.m.custom.color';
  var cfg = null, hexMap = null, hexLoading = false;
  function config() {
    if (cfg) return cfg;
    var el = document.getElementById('abc-color-groups');
    try { cfg = JSON.parse(el.textContent); } catch (e) { cfg = { order: [], groups: {} }; }
    cfg.byValue = {};
    cfg.order.forEach(function (g) {
      (cfg.groups[g].members || []).forEach(function (m) {
        (cfg.byValue[m] = cfg.byValue[m] || []).push(g);
      });
    });
    return cfg;
  }
  function paintSwatch(el, sw) {
    if (!sw) return;
    if (/^(https?:)?\/\//.test(sw)) el.style.background = 'url("' + sw + '") center/cover';
    else if (sw.indexOf(',') > -1) {
      var two = sw.split(',');
      el.style.background = 'linear-gradient(135deg,' + two[0] + ' 50%,' + two[1] + ' 50%)';
    } else el.style.background = sw;
  }
  function loadHex(cb) {
    if (hexMap || hexLoading) return;
    hexLoading = true;
    /* без Accept: application/json — иначе Shopify отдаёт свой JSON страницы */
    fetch('/pages/wishlist?view=abccolors').then(function (r) { return r.ok ? r.text() : null; })
      .then(function (t) { try { hexMap = JSON.parse(t); } catch (e) { hexMap = {}; } cb(); })
      .catch(function () { hexMap = {}; });
  }

  function build(list) {
    var c = config();
    var inputs = [].slice.call(list.querySelectorAll('input[name="' + NAME + '"]'));
    if (!inputs.length) return;
    /* группы в порядке словаря + «сироты» (оттенки вне словаря) */
    var groups = [], seen = {};
    c.order.forEach(function (g) {
      var members = inputs.filter(function (i) { return (c.byValue[i.value.toUpperCase()] || []).indexOf(g) > -1; });
      if (members.length) { groups.push({ key: g, sw: c.groups[g].swatch, inputs: members }); members.forEach(function (i) { seen[i.value] = 1; }); }
    });
    var orphans = inputs.filter(function (i) { return !seen[i.value] && !(c.byValue[i.value.toUpperCase()]); });
    if (orphans.length && !hexMap) loadHex(function () { schedule(); });
    orphans.forEach(function (i) {
      groups.push({ key: i.value.toUpperCase(), sw: (hexMap || {})[i.value.toUpperCase()] || '#DDDDDD', inputs: [i] });
    });

    inputs.forEach(function (i) { var li = i.closest('li'); if (li) li.classList.add('abc-cg-orig'); });

    var box = list.parentNode.querySelector(':scope > .abc-cg');
    if (!box) {
      box = document.createElement('ul');
      box.className = 'abc-cg';
      list.after(box);
    }
    var sig = groups.map(function (g) {
      return g.key + ':' + g.inputs.map(function (i) { return (i.checked ? 1 : 0) + '' + (i.disabled ? 1 : 0); }).join('');
    }).join('|');
    if (box.dataset.sig === sig) return;
    box.dataset.sig = sig;
    box.innerHTML = '';
    groups.forEach(function (g) {
      var on = g.inputs.every(function (i) { return i.checked || i.disabled; }) && g.inputs.some(function (i) { return i.checked; });
      var some = g.inputs.some(function (i) { return i.checked; });
      var off = g.inputs.every(function (i) { return i.disabled; });
      var li = document.createElement('li');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'abc-cg__btn' + (on || some ? ' is-on' : '') + (off ? ' is-disabled' : '');
      b.title = g.key;
      b.setAttribute('aria-label', g.key);
      b.setAttribute('aria-pressed', on || some ? 'true' : 'false');
      if (off) b.disabled = true;
      var sq = document.createElement('span');
      sq.className = 'abc-cg__swatch';
      paintSwatch(sq, g.sw);
      b.appendChild(sq);
      b.addEventListener('click', function () {
        var live = g.inputs.filter(function (i) { return !i.disabled; });
        if (!live.length) return;
        var allOn = live.every(function (i) { return i.checked; });
        live.forEach(function (i) { i.checked = !allOn; });
        /* одно событие change — тема соберёт всю форму и обновит товары один раз */
        live[live.length - 1].dispatchEvent(new Event('change', { bubbles: true }));
      });
      li.appendChild(b);
      box.appendChild(li);
    });
  }

  /* плашки выбранных фильтров: одна «COLOR: GREEN» на группу вместо GREEN + WASABI + … */
  function pills() {
    var c = config();
    var all = [].slice.call(document.querySelectorAll('facet-remove-component'));
    var byGroup = {};
    all.forEach(function (p) {
      var url = p.dataset.abcOrigUrl || p.dataset.url;
      if (!url) return;
      /* название берём из первого текстового узла: в textContent есть
         скрытое слово «Remove» у крестика */
      var node = [].slice.call(p.childNodes).find(function (n) { return n.nodeType === 3 && n.textContent.trim(); });
      if (!p.dataset.abcOrigText && node) p.dataset.abcOrigText = node.textContent.replace(/\s+/g, ' ').trim();
      var m = (p.dataset.abcOrigText || '').match(/^COLOR:\s*(.+)$/i);
      if (!m) return;
      if (!p.dataset.abcOrigUrl) p.dataset.abcOrigUrl = url;
      var val = m[1].toUpperCase();
      var g = (c.byValue[val] || [val])[0];
      var scope = p.closest('dialog') ? 'd' : 'p';
      (byGroup[scope + g] = byGroup[scope + g] || { g: g, pills: [] }).pills.push(p);
    });
    Object.keys(byGroup).forEach(function (k) {
      var item = byGroup[k], members = (c.groups[item.g] || { members: [item.g] }).members;
      item.pills.forEach(function (p, idx) {
        if (idx > 0) { p.classList.add('abc-cg-orig'); return; }
        p.classList.remove('abc-cg-orig');
        var u = new URL(p.dataset.abcOrigUrl, location.origin);
        var keep = u.searchParams.getAll(NAME).filter(function (v) { return members.indexOf(v.toUpperCase()) < 0; });
        u.searchParams.delete(NAME);
        keep.forEach(function (v) { u.searchParams.append(NAME, v); });
        p.dataset.url = u.pathname + (u.search || '');
        var txt = [].slice.call(p.childNodes).find(function (n) { return n.nodeType === 3 && n.textContent.trim(); });
        if (txt) txt.textContent = ' COLOR: ' + item.g + ' ';
      });
    });
  }

  function run() {
    document.querySelectorAll('input[name="' + NAME + '"]').forEach(function (i) {
      var list = i.closest('ul');
      if (list && !list.classList.contains('abc-cg') && !list.dataset.abcCgRun) {
        list.dataset.abcCgRun = '1';
        build(list);
      }
    });
    document.querySelectorAll('ul[data-abc-cg-run]').forEach(function (l) { delete l.dataset.abcCgRun; });
    pills();
  }
  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    /* таймер, а не requestAnimationFrame: rAF не срабатывает, пока вкладка
       не на экране, и группы после перерисовки панели не возвращались */
    setTimeout(function () {
      pending = false;
      try { run(); } catch (e) { console.error('[abc color groups]', e); }
    }, 30);
  }
  /* тема перерисовывает панель после каждого выбора — рисуем группы заново сразу после */
  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'checked']
  });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === NAME) schedule();
  }, true);
  window.abcColorGroups = { run: run, schedule: schedule };
  schedule();
})();

/* ABC: сортировка на телефоне внутри панели фильтра — отдельный раздел
   SORT BY такими же квадратами, как CATEGORY / SIZE (24.09: прежний выпадающий
   список ломался — стили кнопок полосы каталога сплющивали его до 18px,
   а сам список уходил под кнопку SEE). Настоящий select остаётся и получает
   change — применяется вместе с фильтрами по SEE N ITEMS. */
(function () {
  var SHORT = {
    'manual': 'Featured', 'most-relevant': 'Relevance', 'best-selling': 'Best selling',
    'title-ascending': 'A–Z', 'title-descending': 'Z–A',
    'price-ascending': 'Price: low', 'price-descending': 'Price: high',
    'created-ascending': 'Oldest', 'created-descending': 'Newest'
  };
  /* ряды по смыслу (владелец 24.09): пара «по умолчанию», BEST SELLING во всю ширину,
     затем пары A–Z/Z–A, цена low/high, старые/новые. Одинокая кнопка в ряду — во всю ширину. */
  var ROWS = [['manual', 'most-relevant'], ['best-selling'], ['title-ascending', 'title-descending'],
    ['price-ascending', 'price-descending'], ['created-ascending', 'created-descending']];
  function build(sel) {
    var comp = sel.closest('sorting-filter-component');
    if (!comp) return;
    var box = comp.querySelector(':scope > .abc-sortfacet');
    if (!box) {
      box = document.createElement('div');
      box.className = 'abc-sortfacet';
      var title = document.createElement('p');
      title.className = 'abc-sortfacet__title';
      title.textContent = 'Sort by';
      var grid = document.createElement('div');
      grid.className = 'abc-sortfacet__grid';
      grid.setAttribute('role', 'radiogroup');
      grid.setAttribute('aria-label', 'Sort by');
      box.appendChild(title);
      box.appendChild(grid);
      comp.insertBefore(box, comp.firstChild);
    }
    comp.classList.add('abc-sort-ready');
    var grid = box.querySelector('.abc-sortfacet__grid');
    /* перерисовываем только если что-то поменялось — иначе наблюдатель за DOM
       зациклился бы на наших же изменениях */
    var sig = sel.value + '|' + Array.prototype.map.call(sel.options, function (o) { return o.value; }).join(',');
    if (grid.dataset.sig === sig && grid.firstChild) return;
    grid.dataset.sig = sig;
    render(sel, grid);
  }
  function render(sel, grid) {
    var byVal = {};
    Array.prototype.forEach.call(sel.options, function (o) { byVal[o.value] = o; });
    var used = {};
    var order = [];
    ROWS.forEach(function (row) {
      var present = row.filter(function (v) { return byVal[v]; });
      present.forEach(function (v) { used[v] = 1; order.push({ o: byVal[v], wide: present.length === 1 }); });
    });
    /* незнакомые варианты (если Shopify добавит новые) — в конец, во всю ширину */
    Array.prototype.forEach.call(sel.options, function (o) { if (!used[o.value]) order.push({ o: o, wide: true }); });
    grid.innerHTML = '';
    order.forEach(function (it) {
      var o = it.o;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'abc-sortfacet__opt' + (o.selected ? ' is-on' : '') + (it.wide ? ' is-wide' : '');
      b.setAttribute('role', 'radio');
      b.setAttribute('aria-checked', o.selected ? 'true' : 'false');
      b.textContent = SHORT[o.value] || o.text;
      b.addEventListener('click', function () {
        if (o.selected) return;
        sel.value = o.value;
        grid.dataset.sig = '';
        render(sel, grid);
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      });
      grid.appendChild(b);
    });
  }
  function run() {
    document.querySelectorAll('dialog[open] select[name="sort_by"]').forEach(build);
  }
  window.abcSortFacet = { run: run };
  var q = false;
  new MutationObserver(function () {
    if (q) return; q = true;
    setTimeout(function () { q = false; run(); }, 0);
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] });
})();
